import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ApplicationStates } from '../../../../reducers/index.config';

export interface OptOutItem {
    contactId: string
    contactJurisdiction: string,
    processedDate: string
}

export interface OptOut {
    currentPage: number
    optOuts: Array<OptOutItem>,
    totalRecords: number
}

export interface OptOutState {
    data: OptOut,
    loading: boolean;
    loaded: boolean;
    error: any;
}

export const initialOptOutState: OptOutState = {

    data: {
        currentPage: 0,
        optOuts: null,
        totalRecords: 0,
    },
    loading: false,
    loaded: false,
    error: null,
};

export const getOptOutState = createFeatureSelector<OptOutState>(ApplicationStates.OPT_OUT);
export const getOptOutList = createSelector(getOptOutState, (state: OptOutState) => state.data);
